import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { ContentProvider } from "./providers/content.provider";
import { UnitsRoute } from "./routes/units.route";
import { UserRoute } from "./routes/user.route";
import { InfoRoute } from "./routes/info.route";
import { UIProvider } from "./providers/ui.provider";
import { AuthProvider } from "./providers/auth.provider";

function App() {
  return (
    <>
      <Analytics />
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <UIProvider>
              <Routes>
                <Route index path="/" element={<UnitsRoute />} />
                <Route path="/user" element={<UserRoute />} />
                <Route path="/info" element={<InfoRoute />} />
                <Route path="*" element={<UnitsRoute />} />
              </Routes>
            </UIProvider>
          </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </>
  );
}

export default App;
